import currency from "currency.js";

const Money = (value, currencyToUse) => {
  if (value === undefined || isNaN(currency(value).value)) return "";
  if (currencyToUse === "none") return currency(value, { symbol: "" }).format();
  return currency(value).format();
};

export default Money;
